/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelServizioMensaRendicontazioneReportRowDTO } from '../model/paged-model-servizio-mensa-rendicontazione-report-row-dto';
// @ts-ignore
import { PagedModelServizioMensaRicaricaReportRowDTO } from '../model/paged-model-servizio-mensa-ricarica-report-row-dto';
// @ts-ignore
import { ServizioMensaRendicontazioniListFilter } from '../model/servizio-mensa-rendicontazioni-list-filter';
// @ts-ignore
import { ServizioMensaRicaricheListFilter } from '../model/servizio-mensa-ricariche-list-filter';
// @ts-ignore
import { ServizioMensaRicaricheStatisticheDTO } from '../model/servizio-mensa-ricariche-statistiche-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    ServizioMensaReportisticaPagamentiServiceInterface,
    GetServizioMensaPagamentiReportRendicontazioniRequestParams,
    GetServizioMensaPagamentiReportRicaricheRequestParams,
    GetServizioMensaPagamentiReportStatisticheRequestParams
} from './servizio-mensa-reportistica-pagamenti.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ServizioMensaReportisticaPagamentiService extends BaseService implements ServizioMensaReportisticaPagamentiServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Report paginato delle rendicontazioni del servizio.
     * Lista paginata di righe {rendicontazione, intestazione} del servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id, incluse le disabilitate (flag disabilitata in riga). Filtri: numero_mese, nominativo (match ESATTO su studente o genitore). Sort default meseRendicontazione ASC, size default illimitato. Gated su tipoPagamento ∈ {PAGO_PA_RENDICONTAZIONE, PAGO_PA_RENDICONTAZIONE_E_RICARICHE} → 400 servizio_mensa_rendicontazioni_tipo_pagamento_non_abilitato. Audience backoffice (OP_COMUNE/ADMIN/SUPERADMIN).
     * @endpoint get /api/v1/servizi/mensa/rendicontazioni
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioMensaPagamentiReportRendicontazioni(requestParameters: GetServizioMensaPagamentiReportRendicontazioniRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelServizioMensaRendicontazioneReportRowDTO>;
    public getServizioMensaPagamentiReportRendicontazioni(requestParameters: GetServizioMensaPagamentiReportRendicontazioniRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelServizioMensaRendicontazioneReportRowDTO>>;
    public getServizioMensaPagamentiReportRendicontazioni(requestParameters: GetServizioMensaPagamentiReportRendicontazioniRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelServizioMensaRendicontazioneReportRowDTO>>;
    public getServizioMensaPagamentiReportRendicontazioni(requestParameters: GetServizioMensaPagamentiReportRendicontazioniRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling getServizioMensaPagamentiReportRendicontazioni.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling getServizioMensaPagamentiReportRendicontazioni.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getServizioMensaPagamentiReportRendicontazioni.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/rendicontazioni`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelServizioMensaRendicontazioneReportRowDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Report paginato delle ricariche del servizio.
     * Lista paginata di righe {ricarica, intestazione} del servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id. Filtri: data_da/data_a (range date), stato_interno, nominativo (match ESATTO su studente o genitore — cambio contratto FE vs il LIKE legacy), filtra_per_data_pagamento (override; se assente la colonna-data deriva da tipoPagamento&#x3D;&#x3D;MANUALE). Sort default dataPagamento DESC, size default illimitato. Audience backoffice (OP_COMUNE/ADMIN/SUPERADMIN).
     * @endpoint get /api/v1/servizi/mensa/ricariche
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioMensaPagamentiReportRicariche(requestParameters: GetServizioMensaPagamentiReportRicaricheRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelServizioMensaRicaricaReportRowDTO>;
    public getServizioMensaPagamentiReportRicariche(requestParameters: GetServizioMensaPagamentiReportRicaricheRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelServizioMensaRicaricaReportRowDTO>>;
    public getServizioMensaPagamentiReportRicariche(requestParameters: GetServizioMensaPagamentiReportRicaricheRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelServizioMensaRicaricaReportRowDTO>>;
    public getServizioMensaPagamentiReportRicariche(requestParameters: GetServizioMensaPagamentiReportRicaricheRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling getServizioMensaPagamentiReportRicariche.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling getServizioMensaPagamentiReportRicariche.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getServizioMensaPagamentiReportRicariche.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/ricariche`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelServizioMensaRicaricaReportRowDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Statistiche ricariche per anno solare.
     * 12 bucket mensili {numero_mese, anno, totale_ricariche, totale_pagato, totale_in_attesa_pagamento} dell\&#39;anno solare richiesto (mesi senza ricariche → 0.0) + blocco totale &#x3D; somma dei bucket. Il parametro anno è OBBLIGATORIO (400 se assente). La colonna-data segue la stessa risoluzione della lista (filtra_per_data_pagamento o tipoPagamento&#x3D;&#x3D;MANUALE). Audience backoffice (OP_COMUNE/ADMIN/SUPERADMIN).
     * @endpoint get /api/v1/servizi/mensa/ricariche/statistiche
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioMensaPagamentiReportStatistiche(requestParameters: GetServizioMensaPagamentiReportStatisticheRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRicaricheStatisticheDTO>;
    public getServizioMensaPagamentiReportStatistiche(requestParameters: GetServizioMensaPagamentiReportStatisticheRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRicaricheStatisticheDTO>>;
    public getServizioMensaPagamentiReportStatistiche(requestParameters: GetServizioMensaPagamentiReportStatisticheRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRicaricheStatisticheDTO>>;
    public getServizioMensaPagamentiReportStatistiche(requestParameters: GetServizioMensaPagamentiReportStatisticheRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const anno = requestParameters?.anno;
        if (anno === null || anno === undefined) {
            throw new Error('Required parameter anno was null or undefined when calling getServizioMensaPagamentiReportStatistiche.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getServizioMensaPagamentiReportStatistiche.');
        }
        const filtraPerDataPagamento = requestParameters?.filtraPerDataPagamento;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'anno',
            <any>anno,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filtra_per_data_pagamento',
            <any>filtraPerDataPagamento,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/ricariche/statistiche`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRicaricheStatisticheDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
